var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home container"},[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.onNext}},[_vm._v("Next")])],1),_c('Recipe',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }